import { render, staticRenderFns } from "./WAddAssociatedWorkPartnerForm.vue?vue&type=template&id=1f929b2f&scoped=true&"
import script from "./WAddAssociatedWorkPartnerForm.vue?vue&type=script&lang=js&"
export * from "./WAddAssociatedWorkPartnerForm.vue?vue&type=script&lang=js&"
import style0 from "./WAddAssociatedWorkPartnerForm.vue?vue&type=style&index=0&id=1f929b2f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f929b2f",
  null
  
)

export default component.exports